"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "walk", {
  enumerable: true,
  get: function get() {
    return _walk["default"];
  }
});
exports["default"] = void 0;

var _filterWhitespaceNodes = _interopRequireDefault(require("./filterWhitespaceNodes"));

var _walk = _interopRequireDefault(require("./walk"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _filterWhitespaceNodes["default"];
exports["default"] = _default;